export default "__VITE_ASSET__BPkk77RK__"